export const getCustomerCartIdEndpoint = (builder) => ({
    getCustomerCartId: builder.query({
        query: () => ({
            isTrial: false,
            method: "getCustomerCartId",
            params: [],
        }),
        providesTags: ["Cart"],
    }),
});
//# sourceMappingURL=getCustomerCartId.endpoint.js.map